import { useContext } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { SearchCriteria } from './SearchCriteria';
import Results from './Results';
import LoadingSpinner from '../../../library/SimpleControls/LoadingSpinner';

const Layout = () => {
    const { state } = useContext(SmartContext);

    return (
        <div className="main flex-1">
            {!state?.data && <LoadingSpinner />}
            {state?.data && (
                <div className="">
                    <div className="mb-4">
                        <div className="">
                            <div className="">
                                <div className="business_directory_content">
                                    <div className="ActiveListings_present">
                                        <SearchCriteria />
                                        <Results />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Layout;
